<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-tabs v-model="activeName" class="tabs" @tab-click="changeTab">
        <el-tab-pane name="online" label="在线讲座" class="mineCon">
          <div class="newLect flex">
            <div class=" img" :style="'backgroundImage: url('+topLecture.thumbnailPath+')'"></div>
            <div class="rightC">
              <h1 class="overflow">{{ topLecture.title }}</h1>
              <div class="program">
                <p><label class="line"></label>{{ topLecture.subTitle }}</p>
              </div>
              <div class="endTime">
                <el-button size="mini"
                           @click="toDetail(topLecture.id)"
                           :class="topLecture.state==0?'registered':topLecture.state==1?'consultationIn':topLecture.state==2?'joinBtn':'over'">
                  {{ topLecture.stateText }}
                </el-button>
                <span class="joinNum">{{ topLecture.registerCount }}人已报名</span>
              </div>
            </div>
          </div>
          <div class="typeHead">
            <div class="medicineType flex">
              <span class="typeTit">专业分类：</span>
              <div class="medicineTypeL">
                        <span><label :class="active.speciality==0?'activeClass':''"
                                     @click="change(0,1,0)">不限</label></span>
                <span v-for="(item,index) in specialities" :key="index">
                            <label :class="active.speciality==index+1?'activeClass':''"
                                   @click="change(index+1,1,item.id,)">{{ item.itemName }}</label>
                        </span>
              </div>
            </div>
            <div class="medicineType flex">
              <span class="typeTit">讲座分类：</span>
              <div class="medicineTypeL">
                <span><label :class="active.level==0?'activeClass':''" @click="change(0,2,0)">不限</label></span>
                <span v-for="(item,index) in levels" :key="index">
                            <label :class="active.level==index+1?'activeClass':''" @click="change(index+1,2,item.id)">
                            {{ item.itemName }}
                            </label>
                        </span>
              </div>
            </div>
          </div>
          <div class="mineCon flex ">
            <div class="drug " v-for="(obj ,ind) in page.rows" :key="ind">
              <div :style="'backgroundImage: url('+obj.thumbnailPath+')'" class="img "></div>
              <div class="rightC">
                <h3 class="overflow">{{ obj.title }}</h3>
                <p class="overflow">{{ obj.subTitle }}</p>
                <div class="flex signUpBtn">
                  <el-button size="mini"
                             @click="toDetail(obj.id)"
                             :class="obj.state==0?'registered':obj.state==1?'consultationIn':obj.state==2?'joinBtn':'over'">
                    {{ obj.stateText }}
                  </el-button>
                  <span class="joinNum">{{ obj.registerCount }}人已报名</span>
                </div>

              </div>
            </div>
            <div class="empty" v-if="page.rows.length===0">
              <img src="../../assets/img/no.png" alt="" width="200">
              <p>这里什么都没有</p>
            </div>
          </div>
          <el-pagination
              class="pagination"
              :hide-on-single-page="true"
              background
              prev-text="Prev"
              next-text="Next"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next"
              :total="page.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane name="video" label="视频讲座" class="mineCon ">
          <div class="newLect flex">
            <div class=" img" :style="'backgroundImage: url('+topLecture.thumbnailPath+')'"></div>
            <div class="rightC">
              <h1 class="overflow">{{ topLecture.title }}</h1>
              <div class="program">
                <p><label class="line"></label>{{ topLecture.subTitle }}</p>
              </div>
              <div class="endTime">
                <el-button size="mini" class="registered" @click="toVideoDetails(topLecture.id)">立即观看
                </el-button>
                <span class="joinNum">{{ topLecture.registerCount }}人已观看</span>
              </div>
            </div>
          </div>
          <div class="typeHead">
            <div class="medicineType flex">
              <span class="typeTit">专业分类：</span>
              <div class="medicineTypeL">
                        <span><label :class="active.speciality==0?'activeClass':''"
                                     @click="change(0,1,0)">不限</label></span>
                <span v-for="(item,index) in specialities" :key="index">
                            <label :class="active.speciality==index+1?'activeClass':''"
                                   @click="change(index+1,1,item.id,)">{{ item.itemName }}</label>
                        </span>
              </div>
            </div>
            <div class="medicineType flex">
              <span class="typeTit">讲座分类：</span>
              <div class="medicineTypeL">
                <span><label :class="active.level==0?'activeClass':''" @click="change(0,2,0)">不限</label></span>
                <span v-for="(item,index) in levels" :key="index">
                            <label :class="active.level==index+1?'activeClass':''" @click="change(index+1,2,item.id)">
                            {{ item.itemName }}
                            </label>
                        </span>
              </div>
            </div>
          </div>
          <div class="mineCon flex ">
            <div class="drug " v-for="(obj ,ind) in page.rows" :key="ind">
              <div :style="'backgroundImage: url('+obj.thumbnailPath+')'" class="img "></div>
              <div class="rightC">
                <h3 class="title">{{ obj.title }}</h3>
                <div class="flex signUpBtn">
                  <el-button size="mini" class="registered" @click="toVideoDetails(obj.id)">立即观看
                  </el-button>
                  <span class="joinNum">{{ obj.registerCount }}人已观看</span>
                </div>
              </div>
            </div>
            <div class="empty" v-if="page.rows.length===0">
              <img src="../../assets/img/no.png" alt="" width="200">
              <p>这里什么都没有</p>
            </div>
          </div>
          <el-pagination
              class="pagination"
              :hide-on-single-page="true"
              background
              prev-text="Prev"
              next-text="Next"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next"
              :total="page.total">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "lecture",
  data() {
    return {
      activeName: 'online',
      tabName: 'online',
      active: {
        speciality: 0,
        level: 0
      },
      specialities: [],
      levels: [],
      url: '',
      page: {
        current: 1,
        size: 8,
        total: 20,
        specialityId: 0,
        levelId: 0,
        lectureType: 1,
        rows: []
      },
      topLecture: {}
    }
  },
  async mounted() {
    // load 专业分类
    this.$ajax.get(base.api.dict.lecture.speciality).then((res) => {
      if (res.data.status === 'success') {
        this.specialities = res.data.list;
      }
    });
    // load 讲座分类
    this.$ajax.get(base.api.dict.lecture.level).then((res) => {
      if (res.data.status === 'success') {
        this.levels = res.data.list;
      }
    });
    this.url = base.api.expert.lecture.page_auth;
    let loginUser = await base.utils.getCurrent();
    if(!loginUser){
        this.url = base.api.expert.lecture.page_anyone;
    }
    this.getData((item)=>{
      if(item){
        this.topLecture = item;
      }
    });
  },
  methods: {
    changeTab(tab) {
      // 防止重复请求数据
      if (tab.name === this.tabName) {
        return;
      }
      if (tab.name === 'online') {
        this.page.lectureType = 1;
      } else if (tab.name === 'video') {
        this.page.lectureType = 2;
      }

      this.tabName = tab.name;
      this.page.current = 1;
      this.getData((item)=>{
        if(item){
          this.topLecture = item;
        }
      });
    },
    getData(callback) {
      if (this.url) {
        this.$ajax.get(this.url, {
          params: {
            page: this.page.current,
            size: this.page.size,
            specialityId: this.page.specialityId,
            levelId: this.page.levelId,
            lectureType: this.page.lectureType
          }
        }).then((res) => {
          if (res.data.status === 'success') {
            if(this.tabName === 'online'){ // 视频讲座不需要
              $(res.data.rows).each((i, o) => {
                o.stateText = this.stateFmt(o);
              });
            }
            this.page.current = res.data.current;
            this.page.size = res.data.size;
            this.page.total = res.data.total;
            this.page.rows = res.data.rows;
            if (callback) {
              callback(res.data.rows[0]);
            }
          }
        }).catch(err => {
          console.error(err);
          if (err.response.status === 401) { // 未登录
            this.url = base.api.expert.lecture.page_anyone;
            this.getData(callback); // 重新请求 anyone
          }
        })
      }
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
      this.$nextTick(() => {
        $(".contentIndex").animate({scrollTop: '0px'}, 800);
      });
    },
    toDetail(id) {
      this.$router.push({name: 'lectureDetail', query: {id: id}});
    },
    toVideoDetails(id) {
      this.$router.push({name: 'lectureDetail_video', query: {id: id}});
    },
    change(index, type, id) {
      this.page.current = 1;
      if (type === 1) {
        this.active.speciality = index;
        this.page.specialityId = id;
      } else if (type === 2) {
        this.active.level = index;
        this.page.levelId = id;
      }
      this.getData();
    },
    stateFmt(item) {
      //obj.state==0?'已报名':obj.state==1?'授课中':obj.state==2?'期待您的加入':'已结束'
      if (item) {
        //item
        let s = new Date(item.startDate.replace(/-/g, "/"));
        let e = new Date(item.endDate.replace(/-/g, "/"));
        let de = new Date(item.deadlineDate.replace(/-/g, "/"));
        let cur = new Date();

        let stateText = "已结束";
        if (de.getTime() <= cur.getTime()) {
          stateText = "已截止";
          item.state = 3;
        }
        if (e.getTime() <= cur.getTime()) {
          item.state = 3;
          return "已结束";
        }

        if (s.getTime() > cur.getTime()) {
          if (item.isRegistered && item.isRegistered === 1) {
            stateText = "已报名";
            item.state = 0;
          } else {
            stateText = "期待你的加入";
            item.state = 2;
          }
        }
        if (s.getTime() <= cur.getTime() && e.getTime() >= cur.getTime()) {
          stateText = "授课中";
          item.state = 1;
        }
        return stateText;
      }
      return "已结束";
    }
  },
  filters: {}
}
</script>


<style scoped lang="scss">
@import '../../assets/css/medication.scss';

.mineCon {
  margin-top: 0;
}

.typeHead {
  margin-bottom: 20px;
}

.mineCon .drug .rightC h3.title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: normal;
  margin-bottom: 25px;
  height: 48px;
}

.endTime {
  font-size: 13px;
  color: #656565;
  margin-top: 40px;

  .joinNum {
    margin-left: 20px;
  }
}
</style>
